// extracted by mini-css-extract-plugin
module.exports = {"share":"SocialShare_share__A_tB_","item":"SocialShare_item__HM_0B","itemLink":"SocialShare_itemLink__edau_"};